<template>
	<v-container>
		<h1>Налаштування</h1>

		<article>
			<small class="subtitle-2 grey--text">Версія v{{ version }}</small>
		</article>

		<div class="my-4">
			<span class="mr-4">
				Темна тема
			</span>
			<v-btn
				:color="isDark ? 'primary' : undefined"
				outlined
				x-large
				@click="toggleDark">
				<v-icon
					v-if="isDark"
					key="dark">
					mdi-moon-waning-crescent
				</v-icon>
				<v-icon
					v-else
					key="light">
					mdi-white-balance-sunny
				</v-icon>
			</v-btn>
		</div>
		<v-divider></v-divider>

		<v-list class="py-0">
			<v-list-item
				:to="{ name: 'offer-agreement' }"
				title="Переглянути Публічний договір">
				<v-list-item-icon>
					🤝
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>
						Публічний договір
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action>
					<v-icon>mdi-arrow-right</v-icon>
				</v-list-item-action>
			</v-list-item>
			<v-divider></v-divider>

			<v-list-item
				:to="{ name: 'privacy-policy' }"
				title="Переглянути Політику конфіденційності та захисту персональних даних">
				<v-list-item-icon>
					🤫
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>
						Політика конфіденційності та захисту персональних даних
					</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action>
					<v-icon>mdi-arrow-right</v-icon>
				</v-list-item-action>
			</v-list-item>
			<v-divider></v-divider>

			<v-expansion-panels
				:value="[1, 2]"
				multiple
				flat>

				<v-expansion-panel>
					<v-expansion-panel-header class="pl-0 pr-4 py-1">
						<v-list-item>
							<v-list-item-icon>
								🧐
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>
									Про нас
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-container>
							<p>Школа підготовки до ЗНО Brames надає послуги підготовки до ЗНО учнів в офісі в м.Київ  та он-лайн. Ми є приватним закладом з дружньою атмосферою та своїми традиціями. Наша команда — викладачі та випускники КНУ імені Тараса Шевченка. Ми ставимо високі цілі та вміємо їх досягати.</p>

							<p>Послуги надаються шляхом укладення договорів з керівником школи, фізичною особою підприємцем Бондаренком Олександром Володимировичем (КВЕД 85.59). <b>Бондаренко Олександр</b> – кандидат біологічних наук, нейрофізіолог, випускник КНУ імені Тараса Шевченка, має три червоні дипломи в галузі медицини та біології. В 2010 році нагороджений Подякою президента України В.Ющенка за активну громадську діяльність.</p>
						</v-container>
					</v-expansion-panel-content>
					<v-divider></v-divider>
				</v-expansion-panel>

				<v-expansion-panel>
					<v-expansion-panel-header class="pl-0 pr-4 py-1">
						<v-list-item>
							<v-list-item-icon>
								💳
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>
									Оплата
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-container>
							<p class="mb-6">Оплату можна здійснити картками Mastercard/Visa/UnionPay, ApplePay, GooglePay, готівкою в терміналі або ж за допомогою інтернет-банкінгу Приват24. <b>Також можлива оплата частинами</b>.</p>
							<img
								src="assets/icons/liqpay.svg"
								class="mr-4">
							<img
								src="assets/icons/privatbank.svg"
								class="mr-4">
							<img
								src="assets/icons/mastercard.svg"
								class="mr-4">
							<img
								src="assets/icons/visa.svg"
								class="mr-4">
							<img
								src="assets/icons/applePay.svg"
								class="mr-4">
							<img
								src="assets/icons/googlePay.svg"
								class="mr-4">

							<h3 class="mt-6">Повернення коштів</h3>
							<p>
								<ul>
									<li>у разі дострокового розірвання договору впродовж 7 днів після підписання договору кошти, внесені замовником, повертаються в розмірі внесеної суми</li>
									<li>у разі дострокового розірвання договору більше ніж через 7 днів після підписання договору кошти, що були внесені Замовником як плата за надання освітньої послуги не повертаються</li>
								</ul>
							</p>
						</v-container>
					</v-expansion-panel-content>
					<v-divider></v-divider>
				</v-expansion-panel>

				<v-expansion-panel class="mt-0">
					<v-expansion-panel-header class="pl-0 pr-4 py-1">
						<v-list-item>
							<v-list-item-icon>
								☎️
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>
									Контактні дані
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-container>
							<p class="mb-6">У разі виникнення будь-яких питань ви можете звернутись до нас за телефонами <a href="tel:+380977270727" title="Зателефонувати">+380977270727</a>, <a href="tel:+380730270727" title="Зателефонувати">+380730270727</a>, або написавши на <a href="mailto:info@brames.com.ua" title="Написати на емейл">info@brames.com.ua</a></p>

							<p>Також ви можете написати нам напряму у месенджерах:</p>
							<v-card-actions>
								<v-btn
									href="https://t.me/brames_school"
									title="Написати у телеграм"
									target="_blank"
									color="blue"
									depressed
									dark
									fab>
									<v-icon>mdi-telegram</v-icon>
								</v-btn>

								<v-btn
									href="viber://chat?number=+380730270727"
									title="Написати у вайбер"
									color="purple darken-2"
									depressed
									dark
									fab>
									<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="fill: currentColor;" width="24px"><path d="M11.4 0C9.473.028 5.333.344 3.02 2.467 1.302 4.187.696 6.7.633 9.817.57 12.933.488 18.776 6.12 20.36h.003l-.004 2.416s-.037.977.61 1.177c.777.242 1.234-.5 1.98-1.302.407-.44.972-1.084 1.397-1.58 3.85.326 6.812-.416 7.15-.525.776-.252 5.176-.816 5.892-6.657.74-6.02-.36-9.83-2.34-11.546-.596-.55-3.006-2.3-8.375-2.323 0 0-.395-.025-1.037-.017zm.058 1.693c.545-.004.88.017.88.017 4.542.02 6.717 1.388 7.222 1.846 1.675 1.435 2.53 4.868 1.906 9.897v.002c-.604 4.878-4.174 5.184-4.832 5.395-.28.09-2.882.737-6.153.524 0 0-2.436 2.94-3.197 3.704-.12.12-.26.167-.352.144-.13-.033-.166-.188-.165-.414l.02-4.018c-4.762-1.32-4.485-6.292-4.43-8.895.054-2.604.543-4.738 1.996-6.173 1.96-1.773 5.474-2.018 7.11-2.03zm.38 2.602c-.167 0-.303.135-.304.302 0 .167.133.303.3.305 1.624.01 2.946.537 4.028 1.592 1.073 1.046 1.62 2.468 1.633 4.334.002.167.14.3.307.3.166-.002.3-.138.3-.304-.014-1.984-.618-3.596-1.816-4.764-1.19-1.16-2.692-1.753-4.447-1.765zm-3.96.695c-.19-.032-.4.005-.616.117l-.01.002c-.43.247-.816.562-1.146.932-.002.004-.006.004-.008.008-.267.323-.42.638-.46.948-.008.046-.01.093-.007.14 0 .136.022.27.065.4l.013.01c.135.48.473 1.276 1.205 2.604.42.768.903 1.5 1.446 2.186.27.344.56.673.87.984l.132.132c.31.308.64.6.984.87.686.543 1.418 1.027 2.186 1.447 1.328.733 2.126 1.07 2.604 1.206l.01.014c.13.042.265.064.402.063.046.002.092 0 .138-.008.31-.036.627-.19.948-.46.004 0 .003-.002.008-.005.37-.33.683-.72.93-1.148l.003-.01c.225-.432.15-.842-.18-1.12-.004 0-.698-.58-1.037-.83-.36-.255-.73-.492-1.113-.71-.51-.285-1.032-.106-1.248.174l-.447.564c-.23.283-.657.246-.657.246-3.12-.796-3.955-3.955-3.955-3.955s-.037-.426.248-.656l.563-.448c.277-.215.456-.737.17-1.248-.217-.383-.454-.756-.71-1.115-.25-.34-.826-1.033-.83-1.035-.137-.165-.31-.265-.502-.297zm4.49.88c-.158.002-.29.124-.3.282-.01.167.115.312.282.324 1.16.085 2.017.466 2.645 1.15.63.688.93 1.524.906 2.57-.002.168.13.306.3.31.166.003.305-.13.31-.297.025-1.175-.334-2.193-1.067-2.994-.74-.81-1.777-1.253-3.05-1.346h-.024zm.463 1.63c-.16.002-.29.127-.3.287-.008.167.12.31.288.32.523.028.875.175 1.113.422.24.245.388.62.416 1.164.01.167.15.295.318.287.167-.008.295-.15.287-.317-.03-.644-.215-1.178-.58-1.557-.367-.378-.893-.574-1.52-.607h-.018z"/></svg>
								</v-btn>
							</v-card-actions>
						</v-container>
					</v-expansion-panel-content>
					<v-divider></v-divider>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-list>

	</v-container>
</template>

<script>
import { isDark, toggleDark } from '../utils/theme'
import { version } from '../../package.json'

export default {
	setup() {
		return {
			version,
			isDark,
			toggleDark,
		}
	},
}
</script>